






import Vue from 'vue';

export default Vue.extend({
  name: 'IconFont',
  props: {
    iconName: String
  }
});
